export default "__VITE_ASSET__DqZsCN9A__"